import React from 'react';
import './cardItem.scss';

function CardItem(props) {
    return(   
        <div className={props.color}>
            <img className="imageCard" src={props.image} alt={props.title} />
            <h2>{props.title}</h2>                             
            <p>{props.text}</p>
        </div>
    );
}
export default CardItem;